import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { contactJson } from "../modal/contactModal";
import { activityJson, activityJson2 } from "../modal/activityModal";
import { contactDetails, insertContact_Fn } from "../actions/contactActions";
import Year from "../components/Year";
import {
  ContactCreateValidator1_Nepal,
  CountryListJson,
} from "../Model/contactModel";
import { useLocation, useParams } from "react-router-dom";
import "./Internal.css";
import { sourcesHeard } from "../Model/newformModel";
import {
  activityCreateDetails,
  activityDetails,
  activityUpdateDetails,
} from "../actions/activityActions";
import { getintake } from "../actions/intakeActions";
import { getFieldOfStudy } from "../actions/fieldofStudyActions";
import { All_University_Logo } from "../modal/University";
import {
  FiMail,
  FiPhone,
  FiUser,
  FiXCircle,
  FiBookOpen,
  FiFlag,
  FiCalendar,
  FiGlobe,
  FiCompass,
  FiBriefcase,
  FiHelpCircle,
  FiStar,
  FiBookmark,
  FiCheckCircle,
  FiArrowLeft,
  FiArrowRight,
  FiLoader,
  FiAlertTriangle,
  FiRefreshCw,
} from "react-icons/fi";
import { FaGraduationCap } from "react-icons/fa";

// ─── Inline-CSS building blocks for the activity summaries sent to the
// backend. These strings are rendered as raw HTML wherever the CRM displays
// the contact's activity feed, so every rule has to be inline. Only the
// visual formatting changed here — every field/value written into either
// template below is identical to before.
const sectionStyle =
  "background:linear-gradient(135deg,#0a1329,#1c2b52);color:#fff;padding:8px 14px;border-radius:8px;font-size:13px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;margin:14px 0 8px;";
const tableStyle =
  "width:100%;border-collapse:separate;border-spacing:0 6px;margin-bottom:6px;font-family:Arial,Helvetica,sans-serif;";
const thTdStyle1 =
  "padding:8px 12px;font-size:13px;color:#0a1329;font-weight:700;width:44%;background:#f7f8fc;border-radius:6px 0 0 6px;";
const thTdStyle =
  "padding:8px 12px;font-size:13px;color:#2b3467;background:#f7f8fc;border-radius:0 6px 6px 0;";
const thTdStyle2 =
  "padding:8px 12px;font-size:12.5px;color:#5a5a7a;border-bottom:1px solid #eef0f7;";
const thTdStyle3 =
  "padding:10px 14px;font-size:13px;color:#1a1a2e;background:#f7f8fc;border-radius:6px;display:block;";
const clr = "color:#f26524;font-weight:700;";
const gridClr = "color:#f26524;font-weight:700;";

// Same 11 steps as the sibling registration form — purely for the
// presentational progress rail below, reads only the existing `step` value.
const STEP_LABELS = [
  "12th Board",
  "Bachelor's",
  "Master's",
  "Degree",
  "Intake",
  "Country",
  "Field",
  "Work Exp.",
  "Heard From",
  "Contact Type",
  "University",
];

function NepalForm(props) {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(contactJson);
  const [FormError, setFormError] = useState("");
  // const [id2, setid2] = useState(0);
  const [activity, setActivity] = useState(activityJson2);
  const [recid, setrecid] = useState();
  const [Country, setCountry] = useState([]);
  const [Country2, setCountry2] = useState([]);
  const [heardFrom, setHearForm] = useState([]);
  const [Others, setOthers] = useState("");
  const { eventId } = useParams();
  // Three section for three parts:
  const [sec2, setSec2] = useState(true);
  const [sec3, setSec3] = useState(false);
  const [sec4, setSec4] = useState(false);
  const [sec5, setSec5] = useState(false);
  const [step, setStep] = useState(1);
  //   const { countries, loadingCntr, errorCntr } = useSelector(
  //     (state) => state.countryList
  //   );
  //   Prefferd intake
  const intakeList = useSelector((state) => state.intakeList);
  const { intakes } = intakeList;
  useEffect(() => {
    if (!intakes) {
      dispatch(getintake());
    }
  }, [intakes]);
  const fieldsList = useSelector((state) => state.fieldsList);
  const { fields } = fieldsList;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const Lead_Source = params.get("Lead_Source");
  useEffect(() => {
    if (!fields) {
      dispatch(getFieldOfStudy());
    }
  }, [fields]);
  // console.log(details);
  const {
    contact: ContactId3,
    loading: loadingAcc,
    error: errorAcc,
    success: successAcc,
  } = useSelector((s) => s.activityCreateDetailsReducer);
  const {
    contact: ContactId,
    success: successCreate,
    loading: loadingCreate,
    error: errorCreate,
  } = useSelector((state) => state.createContact);
  const {
    loading: loadingAc,
    activityDet,
    eventActivity,
    error: errorAc,
  } = useSelector((s) => s.activityDetailsReducer);
  const {
    contact: ContactIdC,
    loading: loadingAcu,
    success: successAcu,
    error: errorAcu,
  } = useSelector((s) => s.activityUpdateDetailsReducer);
  const {
    contactDet,
    loading: loadingContactDet,
    error: errorContactDet,
  } = useSelector((s) => s.contactDetailsReducer);
  const {
    contact: ContactId2,
    success: successCreate2,
    loading: loadingCreate2,
    error: errorCreate2,
  } = useSelector((state) => state.createContact2);
  const handleClear = (e) => {
    e.preventDefault();
    setDetails({ ...contactJson });
    setrecid("");
  };
  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleStepNext = () => {
    if (step < 11) {
      setStep(step + 1);
    }
  };
  const handleStepPrev = () => {
    if (step !== 1) {
      setStep(step - 1);
    }
  };
  const handleFormChange = (e) => {
    setActivity({ ...activity, [e.target.name]: e.target.value });
  };
  const save2ndStep = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setFormError("");
    var activityHtml = `<div style="font-family:Arial,Helvetica,sans-serif;background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 4px 16px rgba(10,19,41,0.14);">
      <div style="background:linear-gradient(135deg,#0a1329,#1c2b52);color:#fff;padding:10px 16px;font-size:14px;font-weight:700;text-align:center;">
        Personal Information
      </div>
      <table style="width:100%;border-collapse:separate;border-spacing:0 6px;padding:10px 14px 14px;display:table;">
        <tbody>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">Branch: <span style="color:#f26524;font-weight:700;">$$Branch</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">Medium: Form<br/>Event: <span style="color:#f26524;font-weight:700;">${eventId}</span></td>
          </tr>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">Email Address:<br/><span style="color:#2b3467;font-weight:600;">${details.Email_Address}</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">Phone No:<br/><span style="color:#2b3467;font-weight:600;">${details.Phone_No}</span></td>
          </tr>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">First Name:<br/><span style="color:#2b3467;font-weight:600;">${details.First_Name}</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">Last Name:<br/><span style="color:#2b3467;font-weight:600;">${details.Last_Name}</span></td>
          </tr>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">Gender:<br/><span style="color:#2b3467;font-weight:600;">${
              details?.Gender.toString() == "1"
                ? "Male"
                : details?.Gender.toString() == "2"
                  ? "Female"
                  : "Other"
            }</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">Date of Birth:<br/><span style="color:#2b3467;font-weight:600;">${
              details.Date_Of_Birth ? details.Date_Of_Birth : ""
            }</span></td>
          </tr>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">Marital Status:<br/><span style="color:#2b3467;font-weight:600;">${
              details.Marital_Status == "1"
                ? "Unmarried"
                : details.Marital_Status == "2"
                  ? "Married"
                  : "Other"
            }</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">Alternate Phone:<br/><span style="color:#2b3467;font-weight:600;">${details.Phone_No1}</span></td>
          </tr>
          <tr>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:6px 0 0 6px;">City:<br/><span style="color:#2b3467;font-weight:600;">${details.City}</span></td>
            <td style="padding:8px 12px;font-size:12.5px;color:#5a5a7a;background:#f7f8fc;border-radius:0 6px 6px 0;">State:<br/><span style="color:#2b3467;font-weight:600;">${details.State}</span></td>
          </tr>
        </tbody>
      </table>
    </div>`;
    let Validator = ContactCreateValidator1_Nepal({ ...details });
    if (Validator === "success") {
      var dt;
      if (eventId === "") {
        dt = {
          ...details,
          Activity: `Student Form Filled`,
          Activity_Des: activityHtml,
          Lead_Source: Lead_Source || 0,
        };
      } else {
        dt = {
          ...details,
          Activity: `EventTaggedActivity${eventId}`,
          Activity_Des: activityHtml,
          Lead_Source: Lead_Source || 0,
        };
      }
      dispatch(insertContact_Fn({ ...dt, link: window.location.href }));
      //   setSec2(false);
      //   setSec3(false);
      //   setSec4(true);
    } else {
      setFormError(Validator);
    }
    // setSec1(false);
  };
  const save3rdStep = (e) => {
    e.preventDefault();
    e.preventDefault();
    let validator = "success";
    setFormError("");
    var activityHtml = `<div>
      <div
        style="
            background:#fff;
            color:#000;
            border-radius:12px;
            overflow:hidden;
            box-shadow:0 4px 18px rgba(10,19,41,0.16);
            font-family:Arial,Helvetica,sans-serif;
          ">
        <h4 style="
              padding:12px 20px;
              margin:0;
              background:linear-gradient(135deg,#0a1329,#1c2b52);
              color:#fff;
              text-align:center;
              display:flex;
              align-items:center;
              justify-content:center;
              gap:8px;
              font-size:15px;
            ">
          <span>${details?.Contact_Id}</span> - <span>${
            details?.First_Name ? details?.First_Name : details?.full_name
          }</span> <span>${
            activity?.contact_Type == "Yes"
              ? '- <i class="far fa-star" style="color:#ff8a65"></i>'
              : ""
          }</span>
        </h4>

        <div style="padding:14px 18px 18px;">

        <div style=${
          activity?.board || activity.passingYear12 || activity.stream
            ? "margin-top:10px"
            : "display:none;margin-top:10px"
        }>
          <h4 style="${sectionStyle}">Year 12th</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr>
                <td style="${thTdStyle3}">${
                  activity?.board ||
                  activity?.passingYear12 ||
                  activity?.stream
                    ? `${activity.board || "N/A"} - ${activity.passingYear12 || "N/A"} - ${
                        activity.stream || "N/A"
                      } - ${activity.percentage12 || "N/A"}`
                    : ""
                }</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style=${
          activity?.universityUG || activity?.passingYearUG
            ? "margin-top:2px"
            : "display:none"
        }>
          <h4 style="${sectionStyle}">Bachelor's Details</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr>
                <td style="${thTdStyle3}">${
                  activity?.universityUG || activity?.passingYearUG
                    ? `${activity.universityUG || "N/A"} - ${
                        activity.passingYearUG || "N/A"
                      } - ${activity.subjectUG || "N/A"} - ${
                        activity.percentageUG || "N/A"
                      }`
                    : ""
                }</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style=${
          activity?.universityPG || activity?.passingYearPG
            ? "margin-top:2px"
            : "display:none"
        }>
          <h4 style="${sectionStyle}">Master's Details</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr>
                <td style="${thTdStyle3}">${
                  activity?.universityPG || activity?.passingYearPG
                    ? `${activity.universityPG || "N/A"} - ${
                        activity.passingYearPG || "N/A"
                      } - ${activity.subjectPG || "N/A"} - ${
                        activity.percentagePG || "N/A"
                      }`
                    : ""
                }</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style="${sectionStyle}">Preferences</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr style=${
                activity?.preferredDegree || activity?.preferredDegreeOther
                  ? "margin-top:0px"
                  : "display:none"
              }>
                <td style="${thTdStyle1}">Preferred Degree:</td>
                <td style="${thTdStyle}">${
                  activity.preferredDegree
                    ? activity.preferredDegree
                    : activity.preferredDegreeOther
                      ? activity.preferredDegreeOther
                      : ""
                }</td>
              </tr>
              <tr style=${
                Country?.length ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Preferred Country:</td>
                <td style="${thTdStyle}">${
                  Country?.length ? Country?.join(",") : ""
                }</td>
              </tr>
              <tr style=${
                activity.preferredField ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Preferred Field of Study:</td>
                <td style="${thTdStyle}">${activity?.preferredField || ""}</td>
              </tr>
              <tr style=${
                activity?.preferredIntake ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Preferred Intake:</td>
                <td style="${thTdStyle}">${activity?.preferredIntake || ""}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style="${sectionStyle}">Additional Information</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr style=${
                activity.workExperience ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Work Experience:</td>
                <td style="${thTdStyle}">${activity?.workExperience || ""}</td>
              </tr>
              <tr style=${
                activity.givenTest ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Given Test:</td>
                <td style="${thTdStyle}">${activity?.givenTest || ""}</td>
              </tr>
              <tr style=${
                activity.testName ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Test Name:</td>
                <td style="${thTdStyle}">${activity.testName || ""}</td>
              </tr>
              <tr style=${
                heardFrom?.length ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Heard From:</td>
                <td style="${thTdStyle}">${
                  heardFrom?.length ? heardFrom?.join(",") : ""
                }</td>
              </tr>
              <tr style=${
                activity.otherComments ? "margin-top:0px" : "display:none"
              }>
                <td style="${thTdStyle1}">Other Comments:</td>
                <td style="${thTdStyle}">${activity.otherComments || ""}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="personal_info" style="margin-top:1.1px">
          <h4 style="${sectionStyle}">Recommended University</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr>
                <td style="${thTdStyle2}">Recommended Details:</td>
                <td style="${thTdStyle2}">
                  <span style="${gridClr}">${
                    Country2?.length
                      ? Country2.map((item) => item.label).join(", ")
                      : ""
                  }</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="personal_info" style="display:none;margin-top:1.2px">
          <h4 style="${sectionStyle}">Personal Details</h4>
          <table style="${tableStyle}">
            <tbody>
              <tr>
                <td style="${thTdStyle2}">
                  Branch: <span style="${clr}">$$Branch</span>
                </td>
                <td style="${thTdStyle2}">
                  Event: <span style="${clr}">${eventId || ""}</span>
                </td>
              </tr>
              <tr>
                <td style="${thTdStyle2}">
                  Phone: <span style="${clr}">${details.Phone_No || ""}</span>
                </td>
                <td style="${thTdStyle2}">
                  Email Address:<span style="${clr}">${
                    details.Email_Address || ""
                  }</span>
                </td>
              </tr>

              <tr>
                <td style="${thTdStyle2}">
                  First Name:<span style="${clr}"> ${
                    details?.First_Name || ""
                  }</span>
                </td>
                <td style="${thTdStyle2}">
                  Last Name: <span style="${clr}">${
                    details?.Last_Name || ""
                  }</span>
                </td>
              </tr>

              <tr>
                <td style="${thTdStyle2}">
                  Phone No:<span style="${clr}">${
                    details?.Gender?.toString() == "1"
                      ? "Male"
                      : details?.Gender?.toString() == "2"
                        ? "Female"
                        : "Other" || ""
                  }</span>
                </td>
                <td style="${thTdStyle2}">
                  Date of Birth: <span style="${clr}">${
                    details?.Date_Of_Birth || ""
                  }</span>
                </td>
              </tr>

              <tr>
                <td style="${thTdStyle2}">
                  Marital Status:
                  <span style="${clr}"> ${
                    details?.Marital_Status === "1"
                      ? "Unmarried"
                      : details?.Marital_Status === "2"
                        ? "Married"
                        : "Other" || ""
                  }</span>
                </td>
                <td style="${thTdStyle2}">
                  Alternate Phone:
                  <span style="${clr}"> ${details?.Phone_No1 || ""}</span>
                </td>
              </tr>

              <tr>
                <td style="${thTdStyle2}">
                  City:<span style="${clr}"> ${details?.City || ""}</span>
                </td>
                <td style="${thTdStyle2}">
                  State:<span style="${clr}"> ${details?.State || ""}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        </div>
      </div>
    </div>`;
    if (Country?.length == 0) {
      validator = `Error - Preferred Country  is required !`;
    }
    var dt;
    if (eventId === "") {
      dt = {
        ...details,
        ...activity,
        Activity: `Student Form Filled`,
        Activity_Des: activityHtml,
        recommendedCountry: [...Country2?.map((ev) => ev.value)],
        heardFrom: [...heardFrom],
        preferredCountry: [...Country],
        eventId,
      };
    } else {
      dt = {
        ...details,
        ...activity,
        Activity: `EventInteralCounsellorActivity${eventId}`,
        Activity_Des: activityHtml,
        recommendedCountry: [...Country2?.map((ev) => ev.value)],
        heardFrom: [...heardFrom],
        preferredCountry: [...Country],
        eventId,
      };
      //   Activity: `EventTaggedActivity${eventId}`,
    }
    if (validator === "success") {
      if (eventActivity) {
        dispatch(
          activityCreateDetails({
            ...dt,
            contactId: recid,
            link: window.location.href,
            eventUpdate: true,
          }),
        );
      } else {
        dispatch(
          activityCreateDetails({
            ...dt,
            contactId: recid,
            link: window.location.href,
            eventUpdate: false,
          }),
        );
      }
    } else {
      setFormError(validator);
    }
  };
  const save4thStep = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setSec2(false);
    setSec3(true);
    setSec4(false);
    setSec5(false);
    dispatch(contactDetails(recid));
    dispatch(activityDetails(recid, "EventInteralCounsellorActivity"));
  };
  const save5thStep = (e) => {
    e.preventDefault();
    window.location.reload();
  };
  useEffect(() => {
    if (successCreate || successAcc) {
      window.scrollTo(0, 0);
      setSec2(false);
      setSec3(false);
      setSec4(true);
      setSec5(false);
      setrecid(ContactId || ContactId3);
      dispatch(contactDetails(ContactId || ContactId3));
    }
  }, [dispatch, successCreate, successAcc]);
  useEffect(() => {
    if (successCreate2) {
      setDetails(contactJson);
      window.scrollTo(0, 0);
      setSec2(false);
      setSec3(false);
      setSec4(false);
      setSec5(true);
    }
  }, [dispatch, successCreate2]);
  useEffect(() => {
    if (contactDet) {
      setDetails({
        ...details,
        ...contactDet,
      });
    }
  }, [contactDet]);
  useEffect(() => {
    if (eventActivity) {
      let act = {};
      for (let key in eventActivity) {
        if (
          key == "recommendedCountry" ||
          key == "preferredCountry" ||
          key == "heardFrom"
        ) {
          if (eventActivity[key] == "null" || eventActivity[key] == null) {
            act[key] = [];
          } else {
            let mlt = eventActivity[key]?.split(",");
            act[key] = [...mlt];
            if (key == "recommendedCountry") {
              let jkl = [];
              for (let i = 0; i < mlt?.length; i++) {
                let objk = All_University_Logo.find((ev) => ev?.Id == mlt[i]);
                jkl.push({ label: objk?.Name, value: objk?.Id });
              }
              setCountry2([...jkl]);
            } else if (key == "preferredCountry") {
              setCountry([...mlt]);
            } else if (key == "heardFrom") {
              setHearForm([...mlt]);
            }
          }
        } else if (eventActivity[key] == "null" || eventActivity[key] == null) {
          act[key] = "";
        } else {
          act[key] = eventActivity[key];
        }
      }
      setActivity({ ...act });
    }
  }, [eventActivity]);
  return (
    <>
      <Header />
      <div className="custom-header sef-hero">
        <div className="speaking-evaluation">
          <div className="speaking-evaluationOverlay"></div>
          <img
            src="../assets/img/speaking-banner.jpg"
            alt="speaking-banner"
            className="img-fluid"
          />
          <div className="container">
            <div className="speaking-evaluation_title">
              <span className="sef-hero-badge">
                <FiUser size={12} /> Event Student Registration
              </span>
              <h1>Registration Form</h1>
              <div className="sef-hero-underline"></div>
              <p className="sef-hero-sub">
                Share your details and preferences below — our counsellors
                use this to recommend the right courses and universities
                for you.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Main Body */}
      <section className="section-padding bg-f3f3f3 sef-page">
        <div className="container">
          <div className="section-body">
            <div className="speaking-evaluation-body p-lg-5">
              <div className="seaking-evaluation-from">
                <div className="studentDashboard">
                  <div
                    className="my-application Registration-from"
                    id="myApplication"
                  >
                    <div className="row">
                      <div
                        className="col-md-12 "
                        style={{
                          marginTop:
                            window.innerWidth <= 480 ? "-20px" : "-50px",
                          textAlign: "right",
                        }}
                      >
                        {sec4 ? (
                          ""
                        ) : (
                          <button
                            onClick={handleClear}
                            className="btn btn-link sef-clear-btn"
                          >
                            <FiXCircle size={13} /> Clear
                          </button>
                        )}
                      </div>
                      <div className="col-md-12">
                        <div className="custom-tab-details">
                          <div className="tab-content" id="v-pills-tabContent">
                            {/* Personal Information Section */}
                            {sec2 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <h2>Personal Information</h2>
                                    <span className="CourseDescription-broder-btm"></span>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        <FiMail size={13} /> Email Address
                                        <span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Email Address"
                                        name="Email_Address"
                                        required
                                        value={details.Email_Address}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        <FiPhone size={13} /> Mobile Number
                                        <span>*</span>:
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter Number"
                                        name="Phone_No"
                                        required
                                        value={details.Phone_No}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        <FiUser size={13} /> First Name
                                        <span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="First Name"
                                        autoComplete="nope"
                                        required
                                        name="First_Name"
                                        value={details.First_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        <FiUser size={13} /> Last Name
                                        <span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Last Name"
                                        autoComplete="nope"
                                        required
                                        name="Last_Name"
                                        value={details.Last_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {/* Education Detail Section */}
                            {sec3 ? (
                              <>
                                <div className="new_f_C">
                                  <div className="form-container">
                                    <div className="hd_std">
                                      <h2>Education & Preferences Form</h2>
                                      <h5 style={{ color: "#f26524" }}>
                                        <FiUser size={13} />{" "}
                                        {details?.First_Name?.trim()
                                          ? `${details.First_Name} ${
                                              details.Last_Name
                                                ? details.Last_Name
                                                : ""
                                            }`
                                          : details?.full_name}{" "}
                                        {eventActivity ? "(P.C)" : ""}
                                      </h5>
                                    </div>

                                    {/* Step progress rail — purely visual, driven by the existing `step` state */}
                                    <div className="sef-progress-wrap">
                                      {STEP_LABELS.map((label, i) => {
                                        const n = i + 1;
                                        return (
                                          <div
                                            className={`sef-progress-step${
                                              step === n ? " is-active" : ""
                                            }`}
                                            key={n}
                                          >
                                            <div
                                              className={`sef-progress-dot${
                                                step > n
                                                  ? " is-done"
                                                  : step === n
                                                    ? " is-active"
                                                    : ""
                                              }`}
                                            >
                                              {n}
                                            </div>
                                            <span className="sef-progress-label">
                                              {label}
                                            </span>
                                            {n < STEP_LABELS.length && (
                                              <div
                                                className={`sef-progress-line${
                                                  step > n ? " is-done" : ""
                                                }`}
                                              ></div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>

                                    <form>
                                      {/*  step 1 */}
                                      {step == 1 ? (
                                        <>
                                          <label className="head_t">
                                            <FiBookOpen size={14} /> 12th Board
                                            Details
                                          </label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="Board"
                                              name="board"
                                              value={activity?.board}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYear12"
                                              value={activity?.passingYear12}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="Stream"
                                              name="stream"
                                              value={activity?.stream}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Percentage"
                                              name="percentage12"
                                              value={activity?.percentage12}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 2 */}
                                      {step == 2 ? (
                                        <>
                                          <label className="head_t">
                                            <FaGraduationCap size={14} />{" "}
                                            Bachelor Details
                                          </label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="University"
                                              name="universityUG"
                                              value={activity?.universityUG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYearUG"
                                              value={activity?.passingYearUG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="Subject"
                                              name="subjectUG"
                                              value={activity?.subjectUG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="text"
                                              placeholder="Percentage"
                                              name="percentageUG"
                                              value={activity?.percentageUG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 3 */}
                                      {step == 3 ? (
                                        <>
                                          <label className="head_t">
                                            <FaGraduationCap size={14} />{" "}
                                            Masters Details
                                          </label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="University"
                                              name="universityPG"
                                              value={activity?.universityPG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYearPG"
                                              value={activity?.passingYearPG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              placeholder="Subject"
                                              name="subjectPG"
                                              value={activity?.subjectPG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="text"
                                              placeholder="Percentage"
                                              name="percentagePG"
                                              value={activity?.percentagePG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 4 */}
                                      {step == 4 ? (
                                        <>
                                          <label className="head_t">
                                            <FiFlag size={14} /> Preferred
                                            Degree <b>*</b>
                                          </label>
                                          <div className="radio-group prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="degree"
                                                checked={
                                                  activity?.preferredDegree ==
                                                  "UG"
                                                }
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setActivity({
                                                      ...activity,
                                                      preferredDegree: "UG",
                                                    });
                                                  }
                                                }}
                                                id="ug"
                                              />{" "}
                                              <label htmlFor="ug">UG</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                name="degree"
                                                checked={
                                                  activity?.preferredDegree ==
                                                  "PG"
                                                }
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setActivity({
                                                      ...activity,
                                                      preferredDegree: "PG",
                                                    });
                                                  }
                                                }}
                                                id="pg"
                                              />{" "}
                                              <label htmlFor="pg">PG</label>
                                            </div>
                                            <div>
                                              <input
                                                type="text"
                                                name="degree"
                                                placeholder="Other"
                                                value={
                                                  activity?.preferredDegreeOther
                                                }
                                                onChange={(e) =>
                                                  setActivity({
                                                    ...activity,
                                                    preferredDegreeOther:
                                                      e.target.value,
                                                  })
                                                }
                                                id="other"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* Preferred Intake */}
                                      {step == 5 ? (
                                        <>
                                          <label className="head_t">
                                            <FiCalendar size={14} /> Preferred
                                            Intake
                                          </label>
                                          <select
                                            name="preferredIntake"
                                            value={activity?.preferredIntake}
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            {intakes ? (
                                              intakes.map((intak, i) => (
                                                <option
                                                  key={i + 11}
                                                  value={intak.Intake}
                                                >
                                                  {intak.Intake}
                                                </option>
                                              ))
                                            ) : (
                                              <>
                                                <option>Loading...</option>
                                              </>
                                            )}
                                          </select>
                                          <label className="head_t">
                                            <FiCalendar size={14} /> Preferred
                                            Intake Year
                                          </label>
                                          <select
                                            name="preferredIntakeYear"
                                            value={
                                              activity?.preferredIntakeYear
                                            }
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            <Year />
                                          </select>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 5 */}
                                      {step == 6 ? (
                                        <>
                                          <label className="head_t">
                                            <FiGlobe size={14} /> Preferred
                                            Country <b>*</b>
                                          </label>
                                          <div className="checkbox-group cntry">
                                            {CountryListJson?.map((ev, i) => (
                                              <div key={ev?.Id}>
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    Country.indexOf(
                                                      ev?.Country,
                                                    ) == -1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.checked == true
                                                    ) {
                                                      let c = [...Country];
                                                      c.push(ev?.Country);
                                                      setCountry([...c]);
                                                    } else {
                                                      let c = [...Country];
                                                      let index = c.indexOf(
                                                        ev?.Country,
                                                      );
                                                      c.splice(index, 1);
                                                      setCountry([...c]);
                                                    }
                                                  }}
                                                />{" "}
                                                <span>{ev?.Country} </span>
                                              </div>
                                            ))}
                                          </div>
                                          {Country.includes("OTHER") ? (
                                            <div>
                                              <input
                                                type="text"
                                                placeholder="Specify if Other"
                                                name="OtherCountry"
                                                value={activity?.OtherCountry}
                                                onChange={(e) => {
                                                  setActivity({
                                                    ...activity,
                                                    OtherCountry:
                                                      e.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 6 */}
                                      {step == 7 ? (
                                        <>
                                          <label className="head_t">
                                            <FiCompass size={14} /> Preferred
                                            Field of Study
                                          </label>
                                          <select
                                            name="preferredField"
                                            value={activity?.preferredField}
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            {fields ? (
                                              fields.map((field, i) => (
                                                <>
                                                  <option
                                                    key={i + 3}
                                                    value={field.Field_Of_Study}
                                                  >
                                                    {field.Field_Of_Study}
                                                  </option>
                                                </>
                                              ))
                                            ) : (
                                              <>
                                                <option>Loading...</option>
                                              </>
                                            )}
                                          </select>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 8 */}
                                      {step == 8 ? (
                                        <>
                                          <label className="head_t">
                                            <FiBriefcase size={14} /> Work
                                            Experience
                                          </label>
                                          <div className="radio-group  prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="workExperience"
                                                id="yes"
                                                checked={
                                                  activity?.workExperience ==
                                                  "Yes"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    workExperience: "Yes",
                                                  })
                                                }
                                              />
                                              <label htmlFor="yes">Yes</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                id="no"
                                                name="workExperience"
                                                checked={
                                                  activity?.workExperience ==
                                                  "No"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    workExperience: "No",
                                                  })
                                                }
                                              />
                                              <label htmlFor="no">No</label>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 9 */}
                                      {step == 9 ? (
                                        <>
                                          <label className="head_t">
                                            <FiHelpCircle size={14} /> How did
                                            you hear about us? <b>*</b>
                                          </label>
                                          <div className="checkbox-group hear_about">
                                            {sourcesHeard?.map((ev, i) => (
                                              <div key={i + 679}>
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    heardFrom.indexOf(ev) == -1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.checked == true
                                                    ) {
                                                      let c = [...heardFrom];
                                                      c.push(ev);
                                                      setHearForm([...c]);
                                                    } else {
                                                      let c = [...heardFrom];
                                                      let index = c.indexOf(ev);
                                                      c.splice(index, 1);
                                                      setHearForm([...c]);
                                                    }
                                                  }}
                                                />{" "}
                                                <span>{ev} </span>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 10 */}
                                      {step == 10 ? (
                                        <>
                                          <label className="head_t">
                                            <FiStar size={14} /> Contact Type
                                            Important ?
                                          </label>
                                          <div className="radio-group  prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="workExperience"
                                                id="yes"
                                                checked={
                                                  activity?.contact_Type ==
                                                  "Yes"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    contact_Type: "Yes",
                                                  })
                                                }
                                              />
                                              <label htmlFor="yes">Yes</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                id="no"
                                                name="workExperience"
                                                checked={
                                                  activity?.contact_Type == "No"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    contact_Type: "No",
                                                  })
                                                }
                                              />
                                              <label htmlFor="no">No</label>
                                            </div>
                                          </div>
                                          <label className="head_t">
                                            Other Comments
                                          </label>
                                          <textarea
                                            rows="4"
                                            name={"otherComments"}
                                            value={activity?.otherComments}
                                            onChange={handleFormChange}
                                            placeholder="Enter your comments..."
                                          ></textarea>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </form>
                                  </div>
                                </div>
                                {step == 11 ? (
                                  <>
                                    <label className="head_t">
                                      <FiBookmark size={14} /> Recommended
                                      University <b>*</b>
                                    </label>
                                    <div className="form-group fg">
                                      <MultiSelect
                                        options={
                                          All_University_Logo
                                            ? All_University_Logo?.map((el) => {
                                                return {
                                                  label: el.Name,
                                                  value: el.Id,
                                                };
                                              })
                                            : []
                                        }
                                        className="Multi_Selector"
                                        value={Country2}
                                        onChange={(e) => {
                                          setCountry2(e);
                                        }}
                                        labelledBy="Select"
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          flexWrap: "wrap",
                                          gap: "15px",
                                          padding: "6px 0",
                                          alignItems: "center",
                                        }}
                                      >
                                        {Country2?.map((ev) =>
                                          All_University_Logo?.find(
                                            (eb) => eb.Id == ev?.value,
                                          )?.Logo134x64 ? (
                                            <div className="University_Card">
                                              <img
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value,
                                                  )?.Logo134x64
                                                }
                                              />
                                            </div>
                                          ) : All_University_Logo?.find(
                                              (eb) => eb.Id == ev?.value,
                                            )?.Logo50x50 ? (
                                            <div className="University_Card">
                                              <img
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value,
                                                  )?.Logo50x50
                                                }
                                              />
                                            </div>
                                          ) : All_University_Logo?.find(
                                              (eb) => eb.Id == ev?.value,
                                            )?.Logo310x125 ? (
                                            <div className="University_Card">
                                              <img
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value,
                                                  )?.Logo310x125
                                                }
                                              />
                                            </div>
                                          ) : (
                                            <span className="sef-uni-chip-fallback">
                                              {ev?.label}
                                            </span>
                                          ),
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {sec4 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="sef-success">
                                      <div className="sef-success-icon">
                                        <FiCheckCircle size={30} />
                                      </div>
                                      <p>
                                        Thanks for the registration. Your
                                        Registration Id is:
                                      </p>
                                      <strong style={{ fontSize: 26 }}>
                                        {ContactId}
                                      </strong>
                                    </div>
                                    <span className="CourseDescription-broder-btm  mb-4"></span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {sec5 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="sef-success">
                                      <div className="sef-success-icon">
                                        <FiCheckCircle size={30} />
                                      </div>
                                      <p>
                                        Thanks for the registration. Your
                                        Registration Id is:
                                      </p>
                                      <strong style={{ fontSize: 26 }}>
                                        {ContactId2}
                                      </strong>
                                    </div>
                                    <span className="CourseDescription-broder-btm  mb-4"></span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="row">
                            {FormError ? (
                              <div className="sef-alert-error">
                                <FiAlertTriangle size={15} />
                                {FormError}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="col-md-12 custom-form-btn mt-3 text-center">
                              {sec2 ? (
                                <>
                                  <span>&nbsp;</span>
                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save2ndStep(e)}
                                  >
                                    {loadingCreate ? (
                                      <>
                                        <FiLoader
                                          size={14}
                                          className="sef-spin"
                                        />
                                        Loading...
                                      </>
                                    ) : (
                                      <>
                                        <FiArrowRight size={14} /> Submit
                                      </>
                                    )}
                                  </button>
                                  <p>{errorCreate}</p>
                                </>
                              ) : (
                                <></>
                              )}
                              {sec3 ? (
                                <>
                                  {loadingCreate || loadingAcu || loadingAcc ? (
                                    <div className="sef-loading-inline">
                                      <FiLoader
                                        size={16}
                                        className="sef-spin"
                                      />
                                      Loading, please wait...
                                    </div>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "20px",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          type="button"
                                          disabled={loadingAcc}
                                          className="btn form-savebtn sef-btn-ghost"
                                          id="showSucsess"
                                          onClick={(e) => {
                                            handleStepPrev();
                                          }}
                                        >
                                          {loadingCreate2 || loadingAcc ? (
                                            <>
                                              <FiLoader
                                                size={14}
                                                className="sef-spin"
                                              />
                                              Loading...
                                            </>
                                          ) : (
                                            <>
                                              <FiArrowLeft size={14} /> Prev
                                            </>
                                          )}
                                        </button>{" "}
                                        <button
                                          type="button"
                                          className=" btn form-savebtn"
                                          disabled={loadingAcc}
                                          id="showSucsess"
                                          onClick={(e) => {
                                            step == 11
                                              ? save3rdStep(e)
                                              : handleStepNext();
                                          }}
                                        >
                                          {loadingCreate2 || loadingAcc ? (
                                            <>
                                              <FiLoader
                                                size={14}
                                                className="sef-spin"
                                              />
                                              Loading...
                                            </>
                                          ) : step == 11 ? (
                                            <>
                                              <FiCheckCircle size={14} />{" "}
                                              Submit
                                            </>
                                          ) : (
                                            <>
                                              Next <FiArrowRight size={14} />
                                            </>
                                          )}
                                        </button>{" "}
                                      </div>
                                      <p>
                                        {errorCreate2 || errorAcu || errorAcc}
                                      </p>
                                    </>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              {sec4 ? (
                                <>
                                  {successAcc ? (
                                    <button
                                      className=" btn form-savebtn"
                                      id="showSucsess"
                                      onClick={(e) => save5thStep(e)}
                                    >
                                      <FiRefreshCw size={14} /> New
                                      Registration
                                    </button>
                                  ) : (
                                    <button
                                      className=" btn form-savebtn"
                                      id="showSucsess"
                                      onClick={(e) => save4thStep(e)}
                                    >
                                      Continue to Educational Details{" "}
                                      <FiArrowRight size={14} />
                                    </button>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              {sec5 ? (
                                <>
                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save5thStep(e)}
                                  >
                                    <FiRefreshCw size={14} /> New Registration
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </>
  );
}
export default NepalForm;
